import { Component, Input, OnInit } from "@angular/core";
import ScrollReveal from "scrollreveal";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-banner",
  templateUrl: "./banner.component.html",
  styleUrls: ["./banner.component.scss"],
})
export class BannerComponent implements OnInit {

  @Input() title: string = "";
  @Input() linear: boolean = false;

  @Input() description: string = "";
  @Input() cta: string = "";
  @Input() url?: string = "";
  @Input() img: string = "";

  constructor() { }

  ngOnInit(): void { }
}
